import NTopNBottom from '../../components/NTopNBottom'

import bannerImg from '../../assets/trueLove2022/banner.png'
import navColor from '../../assets/trueLove2022/nav/color.png'
import navBg from '../../assets/trueLove2022/nav/nav_bg.png'
import navBgFixed from '../../assets/trueLove2022/nav/nav_bg_fixed.png'

import far1 from '../../assets/trueLove2022/nav/far1.jpg'
import far1_active from '../../assets/trueLove2022/nav/far1_active.jpg'
import far2 from '../../assets/trueLove2022/nav/far2.jpg'
import far2_active from '../../assets/trueLove2022/nav/far2_active.jpg'
import far3 from '../../assets/trueLove2022/nav/far3.jpg'
import far3_active from '../../assets/trueLove2022/nav/far3_active.jpg'
import far4 from '../../assets/trueLove2022/nav/far4.jpg'
import far4_active from '../../assets/trueLove2022/nav/far4_active.jpg'
import far5 from '../../assets/trueLove2022/nav/far5.jpg'
import far5_active from '../../assets/trueLove2022/nav/far5_active.jpg'
import far6 from '../../assets/trueLove2022/nav/far6.jpg'
import far6_active from '../../assets/trueLove2022/nav/far6_active.jpg'
import son1 from '../../assets/trueLove2022/nav/son1.jpg'
import son1_active from '../../assets/trueLove2022/nav/son1_active.jpg'
import son2 from '../../assets/trueLove2022/nav/son2.jpg'
import son2_active from '../../assets/trueLove2022/nav/son2_active.jpg'
import son3 from '../../assets/trueLove2022/nav/son3.jpg'
import son3_active from '../../assets/trueLove2022/nav/son3_active.jpg'
import son4 from '../../assets/trueLove2022/nav/son4.jpg'
import son4_active from '../../assets/trueLove2022/nav/son4_active.jpg'
import son5 from '../../assets/trueLove2022/nav/son5.jpg'
import son5_active from '../../assets/trueLove2022/nav/son5_active.jpg'
import calcRemFn from '../calcRem'

const navCss = {
  navWrap: {
    paddingTop: 0,
    minHeight: calcRemFn(116),
    backgroundImage: `url(${navColor})`,
    boxSizing: 'border-box'
  },
  navCtn: {
    height: calcRemFn(116),
    backgroundImage: `url(${navBg})`,
  },
  navCtnFixed: {
    height: calcRemFn(116),
    backgroundImage: `url(${navBgFixed})`,
  },
  topBtnLayout: {
    alignItems: 'center',
    padding: `${calcRemFn(14)} ${calcRemFn(29)}`,
    paddingRight: `${calcRemFn(55)}`,
    paddingLeft: `${calcRemFn(20)}`,
    paddingBottom: `${calcRemFn(10)}`,
  },
  topBtnBaseCss: {
    width: calcRemFn(31.5),
    height: calcRemFn(15)
  },
  bottomBtnLayout: {
    padding: ` ${calcRemFn(10)} ${calcRemFn(35)}`
  },
  bottomBtnBaseCss: {
    flex: 1,
    height: calcRemFn(20.5),
    margin: `${calcRemFn(5)} ${calcRemFn(5)}`,
    marginTop: 0
  }
}
const navData = {
  // trueLove2022: true,
  component: NTopNBottom,
  top: [
    {
      key: 'top1',
      show: true,
      img: far1,
      img_actived: far1_active,
    },
    {
      key: 'top2',
      show: true,
      img: far2,
      img_actived: far2_active,
    },
    {
      key: 'top3',
      show: true,
      img: far3,
      img_actived: far3_active,
    },
    {
      key: 'top4',
      show: true,
      img: far4,
      img_actived: far4_active,
    },
    {
      key: 'top5',
      show: true,
      img: far5,
      img_actived: far5_active,
    },
    {
      key: 'top6',
      show: true,
      img: far6,
      img_actived: far6_active,
    }
  ],
  bottom: {
    top1: [
      {
        key: '_i1',
        show: true,
        img: son5,
        img_actived: son5_active
      },
      {
        key: '_i2',
        show: true,
        img: son4,
        img_actived: son4_active
      }
    ],
    top2: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active
      },
      {
        key: '_i3',
        show: true,
        img: son3,
        img_actived: son3_active
      }
    ],
    top3: [
      {
        key: '_i1',
        show: true,
        img: son5,
        img_actived: son5_active
      },
      {
        key: '_i2',
        show: true,
        img: son4,
        img_actived: son4_active
      }
    ],
    top4: [
      {
        key: '_i1',
        show: true,
        img: son5,
        img_actived: son5_active
      },
      {
        key: '_i2',
        show: true,
        img: son4,
        img_actived: son4_active
      }
    ],
    top5: [
      {
        key: '_i1',
        show: true,
        img: son5,
        img_actived: son5_active
      },
      {
        key: '_i2',
        show: true,
        img: son4,
        img_actived: son4_active
      }
    ],
    top6: [
      {
        key: '_i1',
        show: true,
        img: son5,
        img_actived: son5_active
      },
      {
        key: '_i2',
        show: true,
        img: son4,
        img_actived: son4_active
      }
    ]
  }
}
const pictureList = [
  {
    key: '1_1',
    picNum: 7,
    pid: 28415
  },
  {
    key: '1_2',
    picNum: 6,
    pid: 28415
  },
  {
    key: '1_3',
    picNum: 0,
    pid: 28415
  },
  {
    key: '2_1',
    picNum: 6,
    pid: 28420
  },
  {
    key: '2_2',
    picNum: 6,
    pid: 28420
  },
  {
    key: '2_3',
    picNum: 4,
    pid: 28421
  },
  {
    key: '3_1',
    picNum: 6,
    pid: 28416
  },
  {
    key: '3_2',
    picNum: 6,
    pid: 28416
  },
  {
    key: '3_3',
    picNum: 0,
    pid: 28421
  },
  {
    key: '4_1',
    picNum: 4,
    pid: 28418
  },
  {
    key: '4_2',
    picNum: 3,
    pid: 28418
  },
  {
    key: '4_3',
    picNum: 0,
    pid: 28421
  },
  {
    key: '5_1',
    picNum: 1,
    pid: 28417
  },
  {
    key: '5_2',
    picNum: 2,
    pid: 28417
  },
  {
    key: '5_3',
    picNum: 0,
    pid: 28421
  },
  {
    key: '6_1',
    picNum: 1,
    pid: 28419
  },
  {
    key: '6_2',
    picNum: 2,
    pid: 28419
  },
  {
    key: '6_3',
    picNum: 0,
    pid: 28421
  },
]
function handlePictures (pictureList) {
  const pictures = []
  pictureList.forEach(item => {
    const { picNum, pid, key, startIndex = 0 } = item
    const picList = []
    Array(picNum).fill(0).forEach((item, index) => {
      picList.push(require(`../../assets/trueLove2022/ctn/${key}_${index + startIndex + 1}.jpg`))
    })
    const indexArr = key.split('_')
    pictures.push({
      id: pid,
      type: 'gold',
      ref: `top${indexArr[0]}_i${indexArr[1]}`,
      farName: `top${indexArr[0]}`,
      sonName: `_i${indexArr[1]}`,
      son: picList
    })
  })
  return pictures
}
const pictures = handlePictures(pictureList)

pictures.unshift({
  son: [
    require('../../assets/trueLove2022/ctn/0_0_0.jpg')
  ],
  fun: 'toNewWedding'
})

const topDiff = {
  firstSon: '_i1'
}
// 2022 致爱照
export default {
  title: '致爱照',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff
}
